import { HttpInterceptorFn } from '@angular/common/http';
import { CAMPOS_FILA_TABLA, limpiarFilaTabla } from '@shared/utils/general/filas-tabla';

// app-table-ultimate entrega copias de las filas con `idListTsi` y `_format`.
// Cuando una de esas filas se reutiliza como body (p.ej. `{ ...row }` al
// modificar), esos campos internos viajarían al backend: aquí se quitan.
// Solo toca bodies JSON (objetos/arrays planos); FormData, Blob, etc. pasan igual.
export const limpiarFilasTablaInterceptor: HttpInterceptorFn = (req, next) => {
  const body = req.body
  if (body == null || typeof body !== 'object' || !contieneCamposTabla(body)) return next(req)
  return next(req.clone({ body: limpiarFilaTabla(body) }))
}

function contieneCamposTabla(valor: unknown): boolean {
  if (Array.isArray(valor)) return valor.some(contieneCamposTabla)
  if (valor === null || typeof valor !== 'object') return false
  const proto = Object.getPrototypeOf(valor)
  if (proto !== Object.prototype && proto !== null) return false
  return Object.entries(valor as Record<string, unknown>).some(([clave, dato]) =>
    (CAMPOS_FILA_TABLA as readonly string[]).includes(clave) || contieneCamposTabla(dato))
}
